import * as React from "react";
import {useState, useEffect} from "react";
import jfetch from "../../utils/jfetch";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Modal from "../core/Modal";
import gravatar from "gravatar";
import VirtualEvents from "../home/VirtualEvents";
const banner = "https://chartec-core-public.s3-us-west-1.amazonaws.com/core_button_1400x65.png";

const BuildFields = (props) => {
  return(
    props.fields.map((val, idx) => {
      let fId = `f-${idx}`;
      return(
        <div key={idx} className="form-group">
          <label htmlFor={fId}>Carousel Image URL - {idx+1}</label>
          <input type="text" className="form-control" data-id={idx} id={fId} aria-describedby={fId+'-help'} placeholder="Image Url" value={props.fields[idx].image_url} onChange={() => handleDynamicChange(props.set_fields, props.fields, event)}/>
          <small id={fId+'-help'} className="form-text text-muted">Enter Image Url 2000x300 (20:3)</small>
          <br/>
          <label htmlFor={fId+'-link'}>Carousel Image Link - {idx+1}</label>
          <input type="text" className="form-control" data-id={idx} id={fId+'-link'} aria-describedby={fId+'-link-help'} placeholder="Image Link" value={props.fields[idx].image_link} onChange={() => handleDynamicChangeLink(props.set_fields, props.fields, event)}/>
          <small id={fId+'-link-help'} className="form-text text-muted">Enter Image Link</small>
          <br/>
          <div className="btn btn-danger" onClick={() => handleRemoveField(props.set_fields, props.fields, idx)}><i className="fa fa-trash"/></div>
          <hr/>
        </div>
      )
    })
  )
}

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

const BuildChat = (props, image) =>{
  let object = '{"username":"'+props.userContext.user.data.attributes.email+'", "name":"'+props.userContext.user.data.attributes.name+'", "room" : "'+props.id+'", "image":"'+image+'", "admin":"'+props.userContext.user.data.attributes.isAdmin+'", "user_company":"'+(props.userContext.organization.data.attributes.name || '')+'", "user_title":"'+(props.userContext.user.data.attributes.jobTitle || '')+'"}';
  let url = 'https://chat.chartec.net/index.html?object='+encodeURI(btoa(object));
  return url;
}

const BuildInfo = (props, image) =>{
  let object = '{"username":"'+props.userContext.user.data.attributes.email+'", "name":"'+props.userContext.user.data.attributes.name+'", "room" : "'+props.id+'", "image":"'+image+'", "admin":"'+props.userContext.user.data.attributes.isAdmin+'", "user_company":"'+(props.userContext.organization.data.attributes.name || '')+'", "user_title":"'+(props.userContext.user.data.attributes.jobTitle || '')+'"}';
  let url = 'https://chat.chartec.net/info.html?object='+encodeURI(btoa(object));
  return url;
}

const BuildLeaderboard = (props) => {
  let object = '{"username":"'+props.userContext.user.data.attributes.email+'"}';
  let url = 'https://chat.chartec.net/leaderboard.html?object='+encodeURI(btoa(object));
  return url;
}

const BuildTodo = (props) => {
  let object = '{"username":"'+props.userContext.user.data.attributes.email+'"}';
  let url = 'https://chat.chartec.net/todo.html?object='+encodeURI(btoa(object));
  return url;
}


function Live(props){
  const is_admin = props.userContext.user.data.attributes.roles.includes("company_admin");
  const [stream, setStream] = useState(Object);
  const [edit, setEdit] = useState(false);
  const [stream_title, set_stream_title] = useState("");
  const [stream_url, set_stream_url] = useState("");
  const [big_image, set_big_image] = useState("");
  const [big_image_link, set_big_image_link] = useState("");
  const [small_image, set_small_image] = useState("");
  const [small_image_link, set_small_image_link] = useState("");
  const [is_live, set_is_live] = useState(false);
  const [error, set_error] = useState(false);
  const [fields, set_fields] = useState(Array);
  const [slide_time, set_slide_time] = useState(6000);
  const [check_update, set_check_update] = useState(0);
  const [offset, setOffset] = useState(0);
  const [group, setGroup] = useState("");
  const [zoomLive, setZoomLive] = useState('')
  const [curEvent, setCurEvent] = useState('')
  const [zoomOpen, setZoomOpen] = useState(false)

  useEffect(() => {
    jfetch.get(`/organizations/${props.userContext.organization.data.id}/show_info`).then((resp) => {
      setGroup(resp.group);
    })
  }, [])
  
  useEffect(() => {
    get_live(props, setStream, set_stream_url, set_big_image, set_small_image, set_is_live, set_stream_title, set_fields, set_small_image_link, set_big_image_link, set_slide_time);
    window.onscroll = () => {
      setOffset(window.pageYOffset)
    }
  }, []);

  useEffect(() => {
    getAPI()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      getAPI()
    }, 10*1000);
    return () => clearInterval(interval);
  }, []);

  async function getAPI(){
    let resp = await fetch(`https://api.chartec.net/v2/core/global_settings/zoom_button_settings`, {
      method: 'GET', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': props.v2_token
      }
    })
    let json = await resp.json();
    let settings = JSON.parse(json[0].json)
    setZoomLive(settings.zoom_live)
    setCurEvent(settings.current_event)
  }

  function usingSafariOrFirefox() {
    // Get the user-agent string
    let userAgentString = navigator.userAgent;
  
    // Detect Chrome
    let chromeAgent = 
        userAgentString.indexOf("Chrome") > -1;
  
    // Detect Internet Explorer
    let IExplorerAgent = 
        userAgentString.indexOf("MSIE") > -1 || 
        userAgentString.indexOf("rv:") > -1;
  
    // Detect Firefox
    let firefoxAgent = 
        userAgentString.indexOf("Firefox") > -1;
  
    // Detect Safari
    let safariAgent = 
        userAgentString.indexOf("Safari") > -1;
          
    // Discard Safari since it also matches Chrome
    if ((chromeAgent) && (safariAgent)) 
        safariAgent = false;
  
    // Detect Opera
    let operaAgent = 
        userAgentString.indexOf("OP") > -1;
          
    // Discard Chrome since it also matches Opera     
    if ((chromeAgent) && (operaAgent)) 
        chromeAgent = false;
  
    return (safariAgent || firefoxAgent)
  }

  useEffect(() => {
    async function check(){
      if(!edit){
        const res = await jfetch.get('/streams/'+props.id+'.json');
        if (res){
          set_big_image(res.stream.big_image);
          set_small_image(res.stream.small_image);
          set_is_live(res.stream.is_live);
          set_stream_title(res.stream.title);
          set_fields(JSON.parse(res.stream.carousel_fields));
          set_small_image_link(res.stream.small_image_link);
          set_big_image_link(res.stream.big_image_link);
          set_slide_time(res.stream.slide_time);
        }
      }
      if(window.location.pathname.includes('/live/')){
        setTimeout(function(){set_check_update(check_update + 1)}, 60000);
      }
    }
    check();
  }, [check_update]);

  if(Object.keys(stream).length){
    return (
      <span>
        {is_admin ? <div className="row" style={{paddingTop : "15px"}}><div style={{marginLeft : "50px"}} className="btn btn-primary" onClick={()=>{setEdit(true)}}>Edit</div><div style={{marginLeft : "10px"}} className="btn btn-primary" onClick={()=>{open_info(BuildInfo(props, gravatar.url(props.userContext.user.data.attributes.email, { s: 95, d: "identicon" })))}}>Info</div></div>:''}
          {group == "Resources Only" || group == "A la Carte" ? <div className="row">
            <div className="col-xs-12 fiftypx-left fiftypx-right">
              <a href="/choose_upgrade">
                <img src={banner} style={{width : '100%'}}/>
              </a>
            </div>
          </div>
          : ""}
          <div className="row" style={{paddingTop:'15px'}}>
            <div className="col-lg-12" style={{paddingLeft:'50px'}}>
              {props.zoomEvents.map((event) => {
                if(zoomLive == 'true' && (curEvent == event.id)){
                  return (
                    <button onClick={() => setZoomOpen(true)} className="btn btn-info btn-lg" key={event.id} style={{marginRight:'10px'}}>
                      {event.title} - Live Now!
                      <div className="blobs-container">
                        <div className="blob red"></div>
                      </div>
                    </button>
                  )
                }
                else{
                  return (
                    <button title="Event is not live yet" className="btn btn-info btn-lg" disabled key={event.id} style={{marginRight:'10px', minHeight:'54px'}}>{event.title}</button>
                  )
                }
              })}
            </div>
          </div>
          <div className="row" style={{paddingTop : "15px"}}>
              <div className="col-xs-12 col-sm-6 col-md-6 fiftypx-left">
                <div className={offset > 120 ? "stuck" : "not-stuck"}><iframe src={stream.stream.stream_url} frameBorder="0" allow="autoplay; fullscreen"></iframe></div>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 fiftypx-right">
                <div style={{padding:"28.25% 0 ", width:"100%", height:"100%", position:"relative"}}><iframe scrolling="no" src={BuildChat(props, gravatar.url(props.userContext.user.data.attributes.email, { s: 95, d: "identicon" }))} style={{position: "absolute",top:0,left:0,width:"100%",height:"100%"}} frameBorder="0"></iframe></div>
              </div>
          </div>
          <div className="row" style={{paddingTop : "15px"}}>
            <div className="col-xs-12 col-sm-6 fiftypx-left">
              <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={slide_time}>
                {fields.map((val, i) => {
                  return(
                    <a rel="noopener noreferrer" target="_blank" key={i} href={fields[i]['image_link']}><img width="100%" src={fields[i]['image_url']}></img></a>
                  )
                })}
              </Carousel>
              <div style={{padding:"100% 0 ", width:"100%", height:"100%", position:"relative"}}><iframe scrolling="yes" src={BuildTodo(props)} style={{position: "absolute",top:0,left:0,width:"100%",height:"100%"}} frameBorder="0"></iframe></div>
            </div>
            {/* <div className="col-xs-12 col-md-6 fiftypx-right">
              <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={slide_time}>
                <a rel="noopener noreferrer" target="_blank" href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=Y9QKZ8A6HSTYG"><img width="100%" src="https://chartec.net/wp-content/uploads/2021/05/DISC.png"></img></a>
                <a rel="noopener noreferrer" target="_blank" href="https://chartec.net/bdr/"><img width="100%" src="https://chartec.net/wp-content/uploads/2021/05/BDR.png"></img></a>
                <a rel="noopener noreferrer" target="_blank" href="https://chartec.net/wp-content/uploads/2021/05/SEOPackages.pdf"><img width="100%" src="https://chartec.net/wp-content/uploads/2021/05/SEO.png"></img></a>
                <a rel="noopener noreferrer" target="_blank" href="https://core.chartec.net/sponsor/rooms/membership"><img width="100%" src="https://chartec-core-images.s3-us-west-1.amazonaws.com/chartec-membership.jpg"></img></a>
              </Carousel>
            </div> */}
            <div className="col-xs-12 col-md-6 fiftypx-right">
                <div style={{padding:"63.25% 0 ", width:"100%", height:"100%", position:"relative"}}><iframe scrolling="yes" src={BuildLeaderboard(props)} style={{position: "absolute",top:0,left:0,width:"100%",height:"100%"}} frameBorder="0"></iframe></div>
            </div>
            {/* <div className="col-xs-12 col-sm-3 fiftypx-right">
              <a rel="noopener noreferrer" target="_blank" href={small_image_link || "#"}><img width="100%" src={small_image}></img></a>
            </div> */}
          </div>
          {/* <div style={{paddingBottom:'50px'}}>
            <VirtualEvents />
          </div> */}
         
            <Modal 
              title="ZOOM Session"
              open={zoomOpen}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => setZoomOpen(false)}
            >
              
                <div>
                  <div className="alert alert-warning">
                    <strong>Attention: </strong> Zoom currently is much better supported in Chrome & Edge Browsers. 
                    If you currently use Firefox or Safari browser we highly recomenned using the zoom app instead.
                  </div>
                </div>
                {usingSafariOrFirefox() ? (
                  <>
                  <div className="text-center">
                    <p>View live event, open: </p>
                  </div>
                  <div className="text-center">
                      <a 
                        className="btn btn-primary"
                        href='/zoom'
                      >
                        Zoom In Browser
                      </a>             
                  </div>
                  </>
                ) : (
                  <>
                  <div className="text-center">
                    <p>View live event, open: </p>
                  </div>
                  <div style={{marginBottom:'10px'}} className="text-center">
                      <a 
                        className="btn btn-primary"
                        href='/zoom'
                      >
                        Zoom In Browser
                      </a>             
                  </div>
                  <div className="text-center">
                      <a 
                        style={{minWidth:'133px'}}
                        className="btn btn-primary"
                        href={props.zoomLink} 
                        target="_blank" rel="noopener noreferrer"
                      >
                        Zoom In App
                      </a> 
                  </div>
                  </>
                )}
              
            </Modal>
          {is_admin ? 
            <Modal
              title="Edit Live Stream"
              open={edit}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => {setEdit(false)}}
            >
              {error ? <div className="alert alert-danger">There was an error!</div>:''}
              <form>
                <div className="form-group">
                  <label htmlFor="stream_title">Stream Title</label>
                  <input type="text" className="form-control" id="stream_title" aria-describedby="stream_title_help" placeholder="Enter Title" value={stream_title} onChange={() => handleChange(set_stream_title, event)}/>
                  <small id="stream_title_help" className="form-text text-muted">Enter the Event Title</small>
                </div>
                <div className="form-group">
                  <label htmlFor="stream_url">Stream URL</label>
                  <input type="text" className="form-control" id="stream_url" aria-describedby="stream_help" placeholder="Enter URL" value={stream_url} onChange={() => handleChange(set_stream_url, event)}/>
                  <small id="stream_help" className="form-text text-muted">Enter the Vimeo Event "Stream" Url</small>
                </div>
                <hr/>
                <div className="form-group">
                  <label htmlFor="big">Big Image URL</label>
                  <input type="text" className="form-control" id="big" aria-describedby="big_help" placeholder="Big Image URL" value={big_image} onChange={() => handleChange(set_big_image, event)}/>
                  <small id="big_help" className="form-text text-muted">Enter the "Big" Image Url (30:37)</small>
                </div>
                <div className="form-group">
                  <label htmlFor="big_link">Big Image Link</label>
                  <input type="text" className="form-control" id="big_link" aria-describedby="big_link_help" placeholder="Big Image Link" value={big_image_link} onChange={() => handleChange(set_big_image_link, event)}/>
                  <small id="big_link_help" className="form-text text-muted">Enter the "Big" Image Link</small>
                </div>
                <hr/>
                <div className="form-group">
                  <label htmlFor="small">Small Image URL</label>
                  <input type="text" className="form-control" id="small" aria-describedby="small_help" placeholder="Small Image URL" value={small_image} onChange={() => handleChange(set_small_image, event)}/>
                  <small id="small_help" className="form-text text-muted">Enter the "Small" Image Url (2:1)</small>
                </div>
                <div className="form-group">
                  <label htmlFor="small_link">Small Image Link</label>
                  <input type="text" className="form-control" id="small_link" aria-describedby="small_link_help" placeholder="Small Image Link" value={small_image_link} onChange={() => handleChange(set_small_image_link, event)}/>
                  <small id="small_link_help" className="form-text text-muted">Enter the "Small" Image Link</small>
                </div>
                <div className="form-group">
                  <label htmlFor="slide_time">Slide Time</label>
                  <input type="text" className="form-control" id="slide_time" aria-describedby="slide_time_help" placeholder="6000" value={slide_time} onChange={() => handleChange(set_slide_time, event)}/>
                  <small id="slide_time_help" className="form-text text-muted">Enter the Slide time in ms (6000 = 6s)</small>
                </div>
                <div className="checkbox">
                  <label><input type="checkbox" style={{marginTop : "-10px"}} onChange={() => handleCheckChange(set_is_live, is_live)} checked={is_live}/> Is Live?</label>
                </div>
                <hr/>
                <div className="btn btn-primary" onClick={()=>{addField(fields, set_fields)}}>Add Carousel Image</div>
                <br/>
                <BuildFields fields={fields} set_fields={set_fields}/>
                <div className="btn btn-primary" onClick={() => {save(props, stream_url, big_image, small_image, set_error, is_live, stream_title, fields, big_image_link, small_image_link, slide_time)}}>Save</div>
              </form>
          </Modal>
        : ''}
      </span>
    )
  } else {
    return(
      <span>
        {is_admin ? <div className="row" style={{paddingTop : "15px"}}><div style={{marginLeft : "50px"}} className="btn btn-primary" onClick={()=>{createStream(props.id)}}>Create Stream</div></div>:''}
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-3 col-md-offset-4">
            <div className="panel panel-default">
              <div className="panel-body">
                <div style={{textAlign: "center"}}>
                <i className="fa fa-cog fa-spin fa-2x"></i><br/>
                Loading
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

async function open_info(link){
  window.open(link, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=800,height=850");
}

function addField(fields, set_fields){
  set_fields(fields => [...fields, {"image_url" : ""}]);
}

async function save(props, stream_url, big_image, small_image, set_error, is_live, stream_title, fields, big_image_link, small_image_link, slide_time){
  const res = await jfetch.patch('/streams/'+props.id, {stream:{stream_url:stream_url, big_image:big_image, small_image:small_image, is_live:is_live, title:stream_title, carousel_fields:JSON.stringify(fields), big_image_link:big_image_link, small_image_link:small_image_link, slide_time:slide_time}});
  if(res){
    if(res.status == "success"){
      location.reload();
    } else {
      set_error(true);
    }
  }
}

function handleRemoveField(hook, fields, idx){
  let cfields = [...fields];
  delete cfields[idx];
  hook(cfields.filter(val => val));
}

async function createStream(id){
  const res = await jfetch.post('/streams', {stream:{id:id, description:"", stream_url:"", big_image:"", big_image_link:"#", small_image:"", small_image_link: "#", is_live:"", title:"", carousel_fields:"[]"}});
    if (res){
      location.reload();
    }
}

function handleDynamicChange(hook, fields, event){
  let cfields = [...fields];
  cfields[event.target.dataset.id]['image_url'] = event.target.value;
  hook(cfields);
}

function handleDynamicChangeLink(hook, fields, event){
  let cfields = [...fields];
  cfields[event.target.dataset.id]['image_link'] = event.target.value;
  hook(cfields);
}

function handleCheckChange(hook, value){
  hook(!value);
}

function handleChange(hook, event){
  hook(event.target.value);
}

async function get_live(props, setStream, set_stream_url, set_big_image, set_small_image, set_is_live, set_stream_title, set_fields, set_small_image_link, set_big_image_link, set_slide_time){
  const res = await jfetch.get('/streams/'+props.id+'.json');
    if (res){
      localStorage.removeItem('stream_url');
      localStorage.removeItem('stream_page');
      setStream(res);
      set_stream_url(res.stream.stream_url);
      localStorage.setItem('stream_url', res.stream.stream_url);
      localStorage.setItem('stream_page', "/live/"+props.id);
      set_big_image(res.stream.big_image);
      set_small_image(res.stream.small_image);
      set_is_live(res.stream.is_live);
      set_stream_title(res.stream.title);
      set_fields(JSON.parse(res.stream.carousel_fields));
      set_small_image_link(res.stream.small_image_link);
      set_big_image_link(res.stream.big_image_link);
      set_slide_time(res.stream.slide_time);
    }
}

export default Live


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Live.tsx